export type NumberFormatter = (number: number | undefined | null, unit?: 'mm' | '%' | 'g' | 'mm³' | 'kg', fractionDigits?: number) => string
export type CurrencyFormatter = (number: number | undefined | null | string) => string

export function useFormatting() {
    const locale = 'de-de'

    const formatDate = (date: string | Date): string => {
        if (typeof date === 'string') {
            return new Date(date).toLocaleString(locale)
        }
        return date.toLocaleString(locale)
    }

    const formatNumber = (number: number | undefined | null, unit?: 'mm' | '%' | 'g' | 'mm³' | 'kg', fractionDigits: number = 2): string => {
        if (number == null) {
            return ''
        }

        const formattedNumber = new Intl.NumberFormat(locale, { maximumFractionDigits: fractionDigits, minimumFractionDigits: fractionDigits }).format(number)
        return unit ? `${formattedNumber} ${unit}` : formattedNumber
    }

    const tryFormatNumber = (number: any, unit?: 'mm' | '%' | 'g' | 'mm³' | 'kg', fractionDigits: number = 2) => {
        if (!number == null) {
            return number
        }
        if (typeof number !== 'number') return number
        return formatNumber(number, unit, fractionDigits)
    }

    const formatCurrency: CurrencyFormatter = (number: number | undefined | null | string): string => {
        if (typeof number === 'string') {
            number = parseInt(number)
        }

        if (number == null) {
            return ''
        }

        return new Intl.NumberFormat(locale, { style: 'currency', currency: 'EUR', minimumFractionDigits: 2, maximumFractionDigits: 2 }).format(number)
    }

    return { formatNumber, formatCurrency, tryFormatNumber, formatDate }
}
